module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    attrs: {
      "enctype": "multipart/form-data"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.sendFile.apply(null, arguments)
      }
    }
  }, [(_vm.message) ? _c('div', {
    class: ("message " + (_vm.error ? 'is-danger' : 'is-success'))
  }, [_c('div', {
    staticClass: "message-body"
  }, [_vm._v(_vm._s(_vm.message))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('div', {
    staticClass: "file-select",
    style: (("display: " + (_vm.uploadedFiles.length>0 ? 'none' : 'flex')))
  }, [_c('label', {
    staticClass: "file-label"
  }, [_c('input', {
    ref: "files",
    staticClass: "file-input",
    attrs: {
      "id": "fileInput",
      "multiple": "",
      "type": "file"
    },
    on: {
      "change": _vm.sendFile
    }
  }), _vm._v(" "), _vm._m(0)])])]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, _vm._l((_vm.uploadedFiles), function(file, index) {
    return _c('div', {
      key: index,
      staticClass: "file-item"
    }, [_c('div', {
      staticClass: "level-top row"
    }, [_c('div', {
      staticClass: "level-left col-lg-12"
    }, [_c('div', {
      staticClass: "global-h-gutter"
    }, [_c('svg', {
      attrs: {
        "width": "48",
        "height": "48",
        "fill": "none",
        "xmlns": "http://www.w3.org/2000/svg"
      }
    }, [_c('circle', {
      attrs: {
        "cx": "24",
        "cy": "24",
        "r": "24",
        "fill": "#F0F4F0"
      }
    }), _vm._v(" "), _c('path', {
      attrs: {
        "d": "M17 16h14v17H17V16z",
        "fill": "#fff",
        "stroke": "#91C855",
        "stroke-width": "2"
      }
    }), _vm._v(" "), _c('path', {
      attrs: {
        "d": "M20.5 24.5h7M20.5 21.5h7M20.5 27.5h7",
        "stroke": "#91C855",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "level-item m-l-20"
    }, [_vm._v(_vm._s(file.name))]), _vm._v(" "), _c('div', {
      staticClass: "level-item delete-button"
    }, [_c('a', {
      staticClass: "delete",
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.uploadedFiles.splice(index, 1)
        }
      }
    })])])]), _vm._v(" "), _c('div', {
      staticClass: "level-bot"
    }, [_c('select', {
      staticClass: "file-type",
      on: {
        "change": function($event) {
          return _vm.onChange(file, $event)
        }
      }
    }, [_c('option', {
      attrs: {
        "disabled": "",
        "selected": ""
      }
    }, [_vm._v("\n            What type of document is this?\n          ")]), _vm._v(" "), _vm._l((_vm.options), function(option, index) {
      return _c('option', {
        key: index
      }, [_vm._v("\n            " + _vm._s(option.text) + "\n          ")])
    })], 2)])])
  }), 0), _vm._v(" "), _c('div', {
    style: (("display: " + (_vm.uploadedFiles.length==0 ? 'none' : 'block')))
  }, [_c('hr'), _vm._v(" "), _c('button', {
    staticClass: "button hollow add-owner",
    on: {
      "click": function($event) {
        return _vm.$refs.files.click()
      }
    }
  }, [_c('svg', {
    attrs: {
      "width": "16",
      "height": "16",
      "viewBox": "0 0 16 16",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M8.66602 2.66699H7.33268V7.33366H2.66602V8.66699H7.33268V13.3337H8.66602V8.66699H13.3327V7.33366H8.66602V2.66699Z",
      "fill": "#053A7A"
    }
  })]), _vm._v("\n      Add Document\n    ")])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "file-button"
  }, [_c('span', {
    staticClass: "file-label"
  }, [_vm._v("\n            Choose file to upload\n          ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e61ba94e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/applyLoan/MultipleUploads.vue
// module id = 2026
// module chunks = 5